import constants from "./constants";
const { BACKEND_URL } = constants;

export async function fetchWithAuth(url, options = {}) {
  const token = localStorage.getItem("auth_token");

  options.headers = {
    "Content-Type": "application/json",
    Authorization: token ? `Bearer ${token}` : "",
    ...options.headers,
  };

  // Ne mets plus jamais le token dans le body
  // options.body reste inchangé

  try {
    const response = await fetch(BACKEND_URL + url, options);

    if (response.status === 401 || response.status === 403) {
      logoutUser();
    }

    return response;
  } catch (error) {
    console.error("Erreur réseau :", error);
    throw error;
  }
}

function logoutUser() {
  localStorage.removeItem("auth_token");
  window.location.href = "/signin";
}
